import { fetchStringToFile } from './fetchStringToFile'

export async function download(url: string, filename: string) {
  const file = await fetchStringToFile(url, filename)
  const link = document.createElement('a')
  link.href = URL.createObjectURL(file)
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
